<template>
  <transition name="slide">
    <div v-if="showToast" class="toast-container">
      <div class="toast">
        <template v-if="isHtmlDisplay" >
          <span v-html="content" />
        </template>
        <template v-else>
          {{ content }}
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
const sleep = (millis) => new Promise(resolve => setTimeout(resolve, millis))
export default {
  name: 'CouponWithCartToast',
  data() {
    return {
      showToast: false,
      content: '',
      isHtmlDisplay: false
    }
  },
  methods: {
    async show({ content, isHtmlDisplay = false }) {
      this.content = content
      this.showToast = true
      this.isHtmlDisplay = isHtmlDisplay
      await sleep(2000)
      this.showToast = false
      this.$emit('dismiss-toast')
    }
  }
}
</script>

<style scoped lang="scss">
.slide-enter-active, .slide-leave-active {
  transition: margin-top 0.3s, opacity 0.3s;
}

.slide-enter, .slide-leave-to {
  margin-top: 24px;
  opacity: 0;
}

.toast-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  pointer-events: none;

  .toast {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    overflow: hidden;
    padding: 20px 30px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
